import {languageOptions} from './constants';

class ToolbarMenus {
    static DEFAULT = [
        {
            tip: 'Clear & Reset',
            label: 'Reset',
            iconClass: 'tde-i tde-i-reset',
            value: 'Mixup',
            // level: 1,
            cssClassNames: 'tde-divider-right',
            shortcutKey : {
                mac : 'command+r',
                windows : 'Ctrl+r'
            }
        },{
            tip: 'Undo / Redo',
            label: 'Undo / Redo',
            iconClass: 'tde-i tde-i-undo-redo',
            groupId: 'undoredo',
            cssClassNames: 'tde-divider-right',
            children: [{
                label: 'Undo',
                value: 'undo',
                shortcutKey : {
                    mac : 'command+z',
                    windows : 'Ctrl+z'
                }
            },
            {
                label: 'Redo',
                value: 'redo',
                shortcutKey : {
                    mac : 'command+y',
                    windows : 'Ctrl+y'
                }
            },
            {
                label: 'Reload Plot',
                value: 'reloadPlot'
            }]
        },{
            tip: 'Dot and Scatter Plot',
            label: 'Dot',
            value: 'Dot',
            dynamicGroup: 'graphs',
            shortcutKey : {
                mac : 'd',
                windows : 'd'
            }
        },{
            tip: 'Line Graph',
            label: 'Line',
            dynamicGroup: 'graphs',
            groupId: 'line',
            children: [{
                label: 'Line Graph',
                value: 'Line',
                // level: 1,
                shortcutKey : {
                    mac : 'l+g',
                    windows : 'l+g'
                }
            },{
                label: 'Line Graph by Category',
                value: 'LineAndCategory',
                // level: 1,
                shortcutKey : {
                    mac : 'l+c',
                    windows : 'l+c'
                }
            }]
        },{
            tip: 'Pie Chart',
            label: 'Pie',
            value: 'Pie',
            // level: 1,
            dynamicGroup: 'graphs',
            shortcutKey : {
                mac : 'p',
                windows : 'p'
            }
        },{
            tip: 'Bar Charts',
            label: 'Bar',
            dynamicGroup: 'graphs',
            groupId: 'bar',
            children: [
                {
                    label: 'Bar Chart of Frequencies',
                    value: 'BarChartOfFreq',
                    // level: 1,
                    // tip: 'Bar Chart of Frequencies',
                    shortcutKey : {
                        mac : 'b+f',
                        windows : 'b+f'
                    }
                },{
                    label: 'Bar Chart of Values',
                    value: 'BarChartOfValues',
                    // level: 1,
                    // tip: 'Bar Chart of Values',
                    shortcutKey : {
                        mac : 'b+v',
                        windows : 'b+v'
                    }
                },{
                    label: 'Bar Chart of Sums',
                    value: 'BarChartOfSums',
                    // level: 1,
                    // tip: 'Bar Chart of Sums',
                    shortcutKey : {
                        mac : 'b+s',
                        windows : 'b+s'
                    }
                },{
                    label: 'Bar Chart of Means',
                    value: 'BarChartOfMeans',
                    // level: 1,
                    // tip: 'Bar Chart of Means',
                    shortcutKey : {
                        mac : 'b+m',
                        windows : 'b+m'
                    }
                },{
                    label: 'Stretched Bar Chart',
                    value: 'StretchedBar',
                    // level: 1,
                    // tip: 'Stretched Bar Chart',
                    shortcutKey : {
                        mac : 'b+t',
                        windows : 'b+t'
                    }
                }
            ]
        },{
            tip: 'Histogram',
            label: 'Hist',
            groupId: 'histGroup',
            dynamicGroup: 'graphs',
            children: [
                {
                    label: 'Frequency Histogram',
                    value: 'FreqHistogram',
                    shortcutKey : {
                        mac : 'h+f',
                        windows : 'h+f'
                    }
                },{
                    label: 'Relative Percentage Histogram',
                    value: 'PercHistogram',
                    shortcutKey : {
                        mac : 'h+p',
                        windows : 'h+p'
                    }
                },{
                    label: 'Relative Proportion Histogram',
                    value: 'PropHistogram',
                    shortcutKey : {
                        mac : 'h+r',
                        windows : 'h+r'
                    }
                }
            ]
        },{
            tip: 'Box Plots',
            label: 'Box',
            groupId: 'box',
            dynamicGroup: 'graphs',
            children: [
                {
                    label: 'Box Plot',
                    value: 'Box',
                    // level: 1,
                    shortcutKey : {
                        mac : 'x+p',
                        windows : 'x+p'
                    }
                },{
                    label: 'Box Plot with Outliers',
                    value: 'BoxAndOutlier',
                    // level: 1,
                    shortcutKey : {
                        mac : 'x+o',
                        windows : 'x+o'
                    }
                },{
                    label: 'Box and Dot Plot',
                    value: 'BoxAndDot',
                    // level: 1,
                    shortcutKey : {
                        mac : 'x+d',
                        windows : 'x+d'
                    }
                }
            ]
        },{
            tip: 'Geographic Map',
            label: 'Map',
            value: 'Map',
            dynamicGroup: 'graphs',
        	shortcutKey : {
            	mac : 'm',
            	windows : 'm'
        	}
		},{
            tip: 'Count and Percent',
            label: 'Count and Percent',
            iconClass: 'tde-i tde-i-num-perc',
            groupId: 'numberpercentage',
            cssClassNames: 'tde-border-left',
            // shortcutKey : {
            //     mac : "Ctrl+Option+n",
            //     windows : "Ctrl+Alt+n"
            // },
            children: [{
                label: 'Count',
                groupId: 'count',
                children: [{
                    label: 'Count Cases',
                    value: 'CellCount',
                    // level: 3
                },{
                    label: 'Count by Section',
                    value: 'SectionCount',
                    // level: 3
                },{
                    label: 'Totals',
                    value: 'SectionSum',
                    // level: 3
                }]
            },{
                label: 'Percent',
                groupId: 'percent',
                children: [{
                    label: 'Percent of Cases',
                    value: 'CellPercent',
                    // level: 3
                },{
                    label: 'Percent in Sections',
                    value: 'SectionPercent',
                    // level: 3
                },{
                    type: 'divider'
                },{
                    label: 'Overall Percent',
                    value: 'OverallPercent',
                    // level: 3
                },{
                    label: 'Percent Column-wise',
                    value: 'ColPercent',
                    // level: 3
                },{
                    label: 'Percent Row-wise',
                    value: 'RowPercent',
                    // level: 3
                }]
            },{
                label: 'Proportion',
                groupId: 'proportion',
                children: [{
                    label: 'Proportion in Sections',
                    value: 'SectionProportion',
                    //level: 3
                }]
            },{
                label: 'Dividers',
                value: 'Dividers',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+p",
                    windows : "Ctrl+Shift+p"
                }
            }]
        },{
            tip: 'Statistical Measures',
            label: 'Stats',
            groupId: 'stats',
            // shortcutKey : {
            //     mac : "Ctrl+Option+s",
            //     windows : "Ctrl+Alt+s"
            // },
            children: [{
                    label: 'Mean',
                    value: 'Mean',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+Ctrl+m",
                        windows : "Ctrl+Shift+m"
                    }
                },{
                    label: 'Median',
                    value: 'Median',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+Ctrl+e",
                        windows : "Ctrl+Shift+e"
                    }
                },{
                    label: 'Mode',
                    value: 'Mode',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+Ctrl+o",
                        windows : "Ctrl+Shift+o"
                    }
                },{
                    label: 'Mean Average Deviation',
                    value: 'MeanAvDev',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+Ctrl+a",
                        windows : "Ctrl+Shift+a"
                    }
                },{
                    label: 'Interquartile Range',
                    value: 'IQR',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+Ctrl+i",
                        windows : "Ctrl+Shift+i"
                    }
                },{
                    label: 'Standard Deviation',
                    value: 'StDev',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+Ctrl+s",
                        windows : "Ctrl+Shift+s"
                    }
                },{
                    label: 'Variance',
                    value: 'Variance',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+Ctrl+v",
                        windows : "Ctrl+Shift+v"
                    }
                },{
                    label: 'Standard Error',
                    value: 'StdError',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+Ctrl+r",
                        windows : "Ctrl+Shift+r"
                    }
                },{
                    label: 'Rounding',
                    groupId: 'precisionGroup',
                    // children: see roundingMenuChildren
                },{
                    label: 'Labels on Statistics',
                    value: 'ShowHideLabelsOnStats',
                    shortcutKey : {
                        mac : "command+Ctrl+l",
                        windows : "Ctrl+Shift+l"
                    }
                }
            ]
        },{
            tip: 'Model Data',
            iconClass: 'tde-i tde-i-model',
            groupId: 'models',
            label: 'Model Data',
            // level: 1,
            children: [{
                ariaLabel: 'Plot Functions',
                label: 'f(x)',
                value: 'modelFunction',
                // level: 2,
                shortcutKey : {
                    mac : "Option+f",
                    windows : "Alt+f"
                }
            },{
                label: 'Least Squares Line',
                groupId: 'leastSqLine',
                children: [{
                    label: 'Least Squares Line',
                    value: 'LeastSqByAttribute',
                    // level: 3,
                    shortcutKey : {
                        mac : "command+Ctrl+u",
                        windows : "Ctrl+Shift+u"
                    }
                },{
                    label: 'Line by Category',
                    value: 'LeastSqByCategory',
                    // level: 3
                }]
            },{
                label: 'Movable Line',
                groupId: 'movableLine',
                children: [
                    {
                        label: 'Add Movable Line on X - Y',
                        value: 'DiagRefLine',
                        // level: 4
                    },{  //-- Inserted dynamically by fillColumnsPropsIntoMenu()
                        label: 'Add Movable Line on X - Y2',
                        value: 'DiagRefLineY2',
                        // level: 4
                    }
                ]
            }, {
                label: 'Reference Lines',
                groupId: 'referenceLines',
                children: [
                    {
                        label: 'Add Reference Line on X',
                        value: 'XRefLine',
                    },{
                        label: 'Add Reference Line on Y',
                        value: 'YRefLine',
                    },{  //-- Inserted dynamically by fillColumnsPropsIntoMenu()
                        label: 'Add Reference Line on Y2',
                        value: 'Y2RefLine',
                    },
                ]
            },{
                label: 'Rulers',
                groupId: 'Rulers',
                children: [
                    {
                        label: 'Add Ruler on X',
                        value: 'RulerX',
                    },{
                        label: 'Add Ruler on Y',
                        value: 'RulerY',
                    }
                ]
            },{
                label: 'Show Squares',
                value: 'ShowHideSquaresOnLines',
                // level: 3,
                shortcutKey : {
                    mac : "command+Ctrl+w",
                    windows : "Ctrl+Shift+w"
                }
            },{
                label: 'Clear All Reference Lines',
                value: 'clearAllRefLines',
                // level: 1,
                shortcutKey : {
                    mac : "command+\\",
                    windows : "Ctrl+\\"
                }
            }
            ]
        },{
            tip: 'Sample Data',
            value: 'randomSample',
            iconClass: 'tde-i tde-i-sample',
            label: 'Sample Data',
            // level: 1,
            shortcutKey : {
                mac : "Option+d",
                windows : "Alt+d"
            }
        },{
            tip: 'Filter Data',
            label: 'Filter Data',
            groupId: 'filterOptions',
            iconClass: 'tde-i tde-i-filter',
            cssClassNames: 'tde-divider-right',
            // shortcutKey : {
            //     mac : "Ctrl+Option+f",
            //     windows : "Ctrl+Alt+f"
            // },
            children: [
                {
                    label: 'Exclude Selected Cases',
                    value: 'excludeSelected',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+e",
                        windows : "Ctrl+e"
                    }
                },
                {
                    label: 'Keep Only Selected Cases',
                    value: 'keepSelected',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+k",
                        windows : "Ctrl+k"
                    }
                },
                {
                    label: 'Filter By',
                    groupId: 'filterBy',
                    fillColumns: true,
                    children: []
                },
                {
                    type: 'divider'
                },
                {
                    label: 'Reset All Filters',
                    value: 'resetAllFilter',
                    // level: 2,
                    shortcutKey : {
                        mac : "command+f",
                        windows : "Ctrl+f"
                    }
                }
            ]
        },{
            // groupId: 'export',
            tip: 'Screenshot',
            label: 'Screenshot',
            value: 'ImagePNG',
            iconClass: 'tde-i tde-i-screenshot',
            // level: 1,
            dynamicGroup: 'more',
            shortcutKey : {
                mac : "command+s",
                windows : "Ctrl+s"
            }
        },{
            tip: 'Annotate',
            label: 'Annotate',
            iconClass: 'tde-i tde-i-annotate',
            groupId: 'annotate',
            dynamicGroup: 'more',
            children: [
                {
                    label: 'Pencil',
                    value: 'AnnotatePencilTool',
                    title: 'Draw a freehand line with Pencil Tool',
                    // level: 1
                },
                {
                    label: 'Rectangle',
                    value: 'AnnotateRectTool',
                    title: 'Draw rectangles with the Rectangle Tool',
                    // level: 1
                },
                {
                    label: 'Circle',
                    value: 'AnnotateCircleTool',
                    title: 'Draw circles with the Circle Tool',
                    // level: 1
                },
                {
                    label: 'Arrow',
                    value: 'AnnotateArrowTool',
                    title: 'Draw arrows with the Arrow Tool',
                    // level: 1
                },
                {
                    label: 'Line',
                    value: 'AnnotateStraightLineTool',
                    title: 'Draw Straight Line with the Line Tool',
                    // level: 1
                },
                {
                    label: 'Text',
                    value: 'AnnotateTextTool',
                    title: 'Add text annotations with the Text Tool',
                    // level: 1
                },
                {
                    label: 'Image',
                    value: 'AnnotateImageTool',
                    title: 'Paste in images with the Image Tool'
                },
                {
                    type: 'divider'
                },
                {
                    label: 'Clear All',
                    value: 'clearAllAnnotations',
                    title: 'Clear all lines, rectangles, circles, arrows, text',
                    // level: 1,
                    shortcutKey : {
                        mac : "command+a",
                        windows : "Ctrl+a"
                    }
                }
            ]
        },{
            tip: 'Settings',
            label: 'Settings',
            value: 'PlotSettings',
            iconClass: 'tde-i tde-i-settings',
            dynamicGroup: 'more',
            // level: 1,
            shortcutKey : {
                mac : "Option+e",
                windows : "Alt+e"
            }

        },{
            // groupId: 'accessibility',
            tip: 'Accessibility',
            label: 'Accessibility',
            // level: 1,
            value: 'AccessibilitySettings',
            iconClass: 'tde-i tde-i-accessibility',
            dynamicGroup: 'more',
            shortcutKey : {
                mac : "Option+z",
                windows : "Alt+z"
            }
        },{
            groupId: 'language',
            tip: 'Language',
            label: 'Language',
            iconClass: 'tde-i tde-i-globe',
            needActiveChildHint: true,
            children: languageOptions.map(lang => {return {...lang, group: 'language', skipLoc: true}})
        },{
            groupId: 'help',
            tip: 'Help',
            label: 'Help',
            iconClass: 'tde-i tde-i-help-fill',
            cssClassNames: 'tde-border-left',
            // level: 1,
            dynamicGroup: '',
            children: [
                {
                    label: 'User Guide',
                    value: 'SupportGuide',
                    title: 'Tuva User Guide',
                    tip: 'Tuva User Guide. Opens in a new tab.',
                    role: 'link'
                },
                {
                    label: 'Support',
                    value: 'Support',
                    title: 'Tuva Tools Support',
                    tip: 'Tuva Tools Support. Opens in a new tab.',
                    role: 'link'
                },
                {
                    label: 'Keyboard Shortcuts',
                    value: 'KeyboardShortcuts',
                    title: 'Keyboard Shortcuts',
                    shortcutKey : {
                        mac : "command+/",
                        windows : "Ctrl+/"
                    }
                },
                {
                    label: 'Tutorials',
                    value: 'Tutorials',
                    title: 'Tutorials',
                    tip: 'Tutorials. Opens in a new tab.',
                    role: 'link'
                },
                {
                    label: 'Tour',
                    value: 'tour',
                    title: 'Tour',
                    tip: 'Tour.'
                }
            ]
        }
    ];

    // For Jr. play view
    static JR_PLAY_INITIAL = [{
        tip: 'Clear & Reset',
        iconClass: 'tde-i tde-i-reset',
        value: 'reset',
        label: 'Reset'
    },
    {
        tip: 'Undo/Redo',
        iconClass: 'tde-i tde-i-undo-redo',
        groupId: 'undoredo',
        children: [{
            label: 'Undo',
            value: 'undo',
            shortcutKey : {
                mac : 'command+z',
                windows : 'Ctrl+z'
            }
        },{
            label: 'Redo',
            value: 'redo',
            shortcutKey : {
                mac : 'command+y',
                windows : 'Ctrl+y'
            }
        }]
    },{
            tip: 'Draw',
            // label: 'Annotate',
            iconClass: 'tde-i tde-i-annotate',
            groupId: 'annotate',
            dynamicGroup: 'more',
            children: [
                {
                    label: 'Pencil',
                    value: 'AnnotatePencilTool',
                    title: 'Draw a freehand line with Pencil Tool',
                },
                {
                    label: 'Rectangle',
                    value: 'AnnotateRectTool',
                    title: 'Draw rectangles with the Rectangle Tool',
                },
                {
                    label: 'Circle',
                    value: 'AnnotateCircleTool',
                    title: 'Draw circles with the Circle Tool',
                },
                {
                    label: 'Arrow',
                    value: 'AnnotateArrowTool',
                    title: 'Draw arrows with the Arrow Tool',
                },
                {
                    label: 'Line',
                    value: 'AnnotateStraightLineTool',
                    title: 'Draw Straight Line with the Line Tool',
                },
                {
                    label: 'Text',
                    value: 'AnnotateTextTool',
                    title: 'Add text annotations with the Text Tool',
                },
                {
                    label: 'Image',
                    value: 'AnnotateImageTool',
                    title: 'Paste in images with the Image Tool'
                },
                {
                    label: 'Dummy Card',
                    value: 'AnnotateCard',
                },
                {
                    label: 'Clear All',
                    value: 'clearAllAnnotations',
                    title: 'Clear all lines, rectangles, circles, arrows, text',
                    shortcutKey : {
                        mac : "command+a",
                        windows : "Ctrl+a"
                    }
                }
            ]
        }]

    // For Jr. play view
    static JR_PLAY = [{
        tip: 'Clear & Reset',
        iconClass: 'tde-i tde-i-reset',
        value: 'reset',
        label: 'Reset'
    },
    {
        tip: 'Undo/Redo',
        iconClass: 'tde-i tde-i-undo-redo',
        groupId: 'undoredo',
        children: [{
            label: 'Undo',
            value: 'undo',
            shortcutKey : {
                mac : 'command+z',
                windows : 'Ctrl+z'
            }
        },{
            label: 'Redo',
            value: 'redo',
            shortcutKey : {
                mac : 'command+y',
                windows : 'Ctrl+y'
            }
        }]
    },{
            tip: 'Draw',
            // label: 'Annotate',
            iconClass: 'tde-i tde-i-annotate',
            groupId: 'annotate',
            dynamicGroup: 'more',
            children: [
                {
                    label: 'Pencil',
                    value: 'AnnotatePencilTool',
                    title: 'Draw a freehand line with Pencil Tool',
                },
                {
                    label: 'Rectangle',
                    value: 'AnnotateRectTool',
                    title: 'Draw rectangles with the Rectangle Tool',
                },
                {
                    label: 'Circle',
                    value: 'AnnotateCircleTool',
                    title: 'Draw circles with the Circle Tool',
                },
                {
                    label: 'Arrow',
                    value: 'AnnotateArrowTool',
                    title: 'Draw arrows with the Arrow Tool',
                },
                {
                    label: 'Line',
                    value: 'AnnotateStraightLineTool',
                    title: 'Draw Straight Line with the Line Tool',
                },
                {
                    label: 'Text',
                    value: 'AnnotateTextTool',
                    title: 'Add text annotations with the Text Tool',
                },
                {
                    label: 'Image',
                    value: 'AnnotateImageTool',
                    title: 'Paste in images with the Image Tool'
                },
                {
                    label: 'Dummy Card',
                    value: 'AnnotateCard',
                    title: 'Draw a dummy card with the Dummy Card Tool',
                },
                {
                    label: 'Clear All',
                    value: 'clearAllAnnotations',
                    title: 'Clear all lines, rectangles, circles, arrows, text',
                    shortcutKey : {
                        mac : "command+a",
                        windows : "Ctrl+a"
                    }
                }
            ]
        },
    // Spread
    {
        tip: 'Spread',
        iconClass: 'tde-i tde-i-up-down-arrow',
        label: 'Spread',
        value: 'spread',
    },
    // Icons
    {
        tip: 'Icons',
        iconClass: 'tde-i tde-i-icons',
        label: 'Icons',
        value: 'icons',
    },
    // Count
    {
        tip: 'Count',
        iconClass: 'tde-i tde-i-count',
        label: 'Count',
        value: 'count',
    },{
        tip: 'Picture',
        // label: 'Screenshot',
        value: 'ImagePNG',
        iconClass: 'tde-i tde-i-screenshot',
        // level: 1,
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "command+s",
            windows : "Ctrl+s"
        }
    }];
    // For Jr plot view
    static JR = [{
        tip: 'Clear & Reset',
        iconClass: 'tde-i tde-i-reset',
        value: 'Mixup',
        // level: 1,
        label: 'Reset',
        shortcutKey : {
            mac : 'command+r',
            windows : 'Ctrl+r'
        }
    },{
        tip: 'Undo/Redo',
        iconClass: 'tde-i tde-i-undo-redo',
        groupId: 'undoredo',
        children: [{
            label: 'Undo',
            value: 'undo',
            shortcutKey : {
                mac : 'command+z',
                windows : 'Ctrl+z'
            }
        },
        {
            label: 'Redo',
            value: 'redo',
            shortcutKey : {
                mac : 'command+y',
                windows : 'Ctrl+y'
            }
        },
        {
            label: 'Reload Plot',
            value: 'reloadPlot'
        }]
    },{
        tip: 'Dot and Scatter Plot',
        iconClass: 'tde-i tde-i-dot',
        label: 'Dot',
        value: 'Dot',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'd',
            windows : 'd'
        }
    },{
        tip: 'Line Graph',
        iconClass: 'tde-i tde-i-line',
        label: 'Line Graph',
        value: 'Line',
        dynamicGroup: 'graphs',
        groupId: 'line',
        children: [{
            label: 'Line Graph',
            value: 'Line',
            // level: 1,
            shortcutKey : {
                mac : 'l+g',
                windows : 'l+g'
            }
        },{
            label: 'Line Graph by Category',
            value: 'LineAndCategory',
            // level: 1,
            shortcutKey : {
                mac : 'l+c',
                windows : 'l+c'
            }
        }]
    },
    {
        tip: 'Pie Chart',
        iconClass: 'tde-i tde-i-pie',
        label: 'Pie',
        value: 'Pie',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'p',
            windows : 'p'
        }
    },{
        tip: 'Bar Chart',
        iconClass: 'tde-i tde-i-bar',
        label: 'Bar',
        dynamicGroup: 'graphs',
        groupId: 'bar',
        children: [
            {
                label: 'Bar Chart of Values',
                value: 'BarChartOfValues',
                // level: 1,
                // tip: 'Bar Chart of Values',
                shortcutKey : {
                    mac : 'b+v',
                    windows : 'b+v'
                }
            },{
                label: 'Bar Chart of Sums',
                value: 'BarChartOfSums',
                // level: 1,
                // tip: 'Bar Chart of Sums',
                shortcutKey : {
                    mac : 'b+s',
                    windows : 'b+s'
                }
            },{
                label: 'Bar Chart of Frequencies',
                value: 'BarChartOfFreq',
                // level: 1,
                // tip: 'Bar Chart of Frequencies',
                shortcutKey : {
                    mac : 'b+f',
                    windows : 'b+f'
                }
            },{
                label: 'Stretched Bar Chart',
                value: 'StretchedBar',
                // level: 1,
                // tip: 'Stretched Bar Chart',
                shortcutKey : {
                    mac : 'b+t',
                    windows : 'b+t'
                }
            }
        ]
    },{
        tip: 'Map',
        iconClass: 'tde-i tde-i-map',
        label: 'Map',
        value: 'Map',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'm',
            windows : 'm'
        }
    },{
        tip: 'Counts and Percents',
        label: 'Count',
        iconClass: 'tde-i tde-i-num-perc',
        groupId: 'numberpercentage',
        children: [{
            label: 'Count',
            groupId: 'count',
            children: [{
                label: 'Count Cases',
                value: 'CellCount',
                // level: 3
            },{
                label: 'Count by Section',
                value: 'SectionCount',
                // level: 3
            },{
                label: 'Totals',
                value: 'SectionSum',
                // level: 3
            }]
        },{
            label: 'Percent',
            groupId: 'percent',
            children: [{
                label: 'Percent of Cases',
                value: 'CellPercent',
                // level: 3
            },{
                label: 'Percent in Sections',
                value: 'SectionPercent',
                // level: 3
            },{
                type: 'divider'
            },{
                label: 'Overall Percent',
                value: 'OverallPercent',
                // level: 3
            },{
                label: 'Percent Column-wise',
                value: 'ColPercent',
                // level: 3
            },{
                label: 'Percent Row-wise',
                value: 'RowPercent',
                // level: 3
            }]
        }]
    },
    {
        tip: 'Averages',
        iconClass: 'tde-i tde-i-average',
        label: 'Averages',
        groupId: 'stats',
        children: [{
                label: 'Mean',
                value: 'Mean',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+m",
                    windows : "Ctrl+Shift+m"
                }
            },{
                label: 'Median',
                value: 'Median',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+e",
                    windows : "Ctrl+Shift+e"
                }
            },{
                label: 'Mode',
                value: 'Mode',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+o",
                    windows : "Ctrl+Shift+o"
                }
            },{
                label: 'Rounding',
                groupId: 'precisionGroup',
                // children: see roundingMenuChildren
            },{
                label: 'Labels on Statistics',
                value: 'ShowHideLabelsOnStats',
                shortcutKey : {
                    mac : "command+Ctrl+l",
                    windows : "Ctrl+Shift+l"
                }
            }
        ]
    },
    {
        tip: 'Lines',
        iconClass: 'tde-i tde-i-model',
        groupId: 'models',
        label: 'Lines',
        // level: 1,
        children: [
        {
            label: 'Dividers',
            value: 'Dividers',
            // level: 2,
            shortcutKey : {
                mac : "command+Ctrl+p",
                windows : "Ctrl+Shift+p"
            }
        },
        {
            label: 'Movable Line',
            children: [
                {
                    label: 'Add Movable Line on X - Y',
                    value: 'DiagRefLine',
                    // level: 4
                },{  //-- Inserted dynamically by fillColumnsPropsIntoMenu()
                    label: 'Add Movable Line on X - Y2',
                    value: 'DiagRefLineY2',
                    // level: 4
                }
            ]
        }, {
            label: 'Reference Lines',
            children: [
                {
                    label: 'Add Reference Line on X',
                    value: 'XRefLine',
                    // level: 4
                },{
                    label: 'Add Reference Line on Y',
                    value: 'YRefLine',
                    // level: 4
                },
            ]
        },{
            label: 'Clear All Reference Lines',
            value: 'clearAllRefLines',
            // level: 1,
            shortcutKey : {
                mac : "command+\\",
                windows : "Ctrl+\\"
            }
        }
        // ,{
        //     label: 'Clear All Reference Lines',
        //     value: 'clearAllRefLines',
        //     level: 1,
        //     shortcutKey : {
        //         mac : "command+\\",
        //         windows : "Ctrl+\\"
        //     }
        // }
    ]
    },{
        tip: 'Remove Cases',
        // label: 'Filter Data',
        groupId: 'filterOptions',
        iconClass: 'tde-i tde-i-filter',
        children: [
            {
                label: 'Exclude Selected Cases',
                value: 'excludeSelected',
                // level: 2,
                shortcutKey : {
                    mac : "command+e",
                    windows : "Ctrl+e"
                }
            },
            {
                label: 'Keep Only Selected Cases',
                value: 'keepSelected',
                // level: 2,
                shortcutKey : {
                    mac : "command+k",
                    windows : "Ctrl+k"
                }
            },
            {
                label: 'Filter By',
                groupId: 'filterBy',
                fillColumns: true,
                children: []
            },
            {
                type: 'divider'
            },
            {
                label: 'Reset All Filters',
                value: 'resetAllFilter',
                // level: 2,
                shortcutKey : {
                    mac : "command+f",
                    windows : "Ctrl+f"
                }
            }
        ]
    },{
        tip: 'Draw',
        // label: 'Annotate',
        iconClass: 'tde-i tde-i-annotate',
        groupId: 'annotate',
        dynamicGroup: 'more',
        children: [
            {
                label: 'Pencil',
                value: 'AnnotatePencilTool',
                title: 'Draw a freehand line with Pencil Tool',
                // level: 1
            },
            {
                label: 'Rectangle',
                value: 'AnnotateRectTool',
                title: 'Draw rectangles with the Rectangle Tool',
                // level: 1
            },
            {
                label: 'Circle',
                value: 'AnnotateCircleTool',
                title: 'Draw circles with the Circle Tool',
                // level: 1
            },
            {
                label: 'Arrow',
                value: 'AnnotateArrowTool',
                title: 'Draw arrows with the Arrow Tool',
                // level: 1
            },
            {
                label: 'Line',
                value: 'AnnotateStraightLineTool',
                title: 'Draw Straight Line with the Line Tool',
                // level: 1
            },
            {
                label: 'Text',
                value: 'AnnotateTextTool',
                title: 'Add text annotations with the Text Tool',
                // level: 1
            },
            {
                label: 'Image',
                value: 'AnnotateImageTool',
                title: 'Paste in images with the Image Tool'
            },
            {
                type: 'divider'
            },
            {
                label: 'Clear All',
                value: 'clearAllAnnotations',
                title: 'Clear all lines, rectangles, circles, arrows, text',
                // level: 1,
                shortcutKey : {
                    mac : "command+a",
                    windows : "Ctrl+a"
                }
            }
        ]
    },{
        tip: 'Picture',
        // label: 'Screenshot',
        value: 'ImagePNG',
        iconClass: 'tde-i tde-i-screenshot',
        // level: 1,
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "command+s",
            windows : "Ctrl+s"
        }
    },
    {
        tip: 'Plot Settings',
        // label: 'Settings',
        value: 'PlotSettings',
        iconClass: 'tde-i tde-i-settings',
        dynamicGroup: 'more',
        // level: 1,
        shortcutKey : {
            mac : "Option+e",
            windows : "Alt+e"
        }

    },{
        // groupId: 'accessibility',
        tip: 'Accessibility',
        // label: 'Accessibility',
        // level: 1,
        value: 'AccessibilitySettings',
        iconClass: 'tde-i tde-i-accessibility',
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "Option+z",
            windows : "Alt+z"
        }
    }];

    static ELEM = [{
        tip: 'Clear & Reset',
        iconClass: 'tde-i tde-i-reset',
        value: 'Mixup',
        // level: 1,
        cssClassNames: 'tde-divider-right',
        shortcutKey : {
            mac : 'command+r',
            windows : 'Ctrl+r'
        }
    },{
        tip: 'Undo / Redo',
        iconClass: 'tde-i tde-i-undo-redo',
        groupId: 'undoredo',
        cssClassNames: 'tde-divider-right',
        children: [{
            label: 'Undo',
            value: 'undo',
            shortcutKey : {
                mac : 'command+z',
                windows : 'Ctrl+z'
            }
        },
        {
            label: 'Redo',
            value: 'redo',
            shortcutKey : {
                mac : 'command+y',
                windows : 'Ctrl+y'
            }
        },
        {
            label: 'Reload Plot',
            value: 'reloadPlot'
        }]
    },{
        tip: 'Dot and Scatter Plot',
        label: 'Dot',
        value: 'Dot',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'd',
            windows : 'd'
        }
    },{
        tip: 'Line Graph',
        label: 'Line',
        dynamicGroup: 'graphs',
        groupId: 'line',
        children: [{
            label: 'Line Graph',
            value: 'Line',
            // level: 1,
            shortcutKey : {
                mac : 'l+g',
                windows : 'l+g'
            }
        }]
    },{
        tip: 'Pie Chart',
        label: 'Pie',
        value: 'Pie',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'p',
            windows : 'p'
        }
    },{
        tip: 'Bar Charts',
        label: 'Bar',
        dynamicGroup: 'graphs',
        groupId: 'bar',
        children: [
            {
                label: 'Bar Chart of Frequencies',
                value: 'BarChartOfFreq',
                // level: 1,
                // tip: 'Bar Chart of Frequencies',
                shortcutKey : {
                    mac : 'b+f',
                    windows : 'b+f'
                }
            },{
                label: 'Bar Chart of Values',
                value: 'BarChartOfValues',
                // level: 1,
                // tip: 'Bar Chart of Values',
                shortcutKey : {
                    mac : 'b+v',
                    windows : 'b+v'
                }
            },{
                label: 'Bar Chart of Sums',
                value: 'BarChartOfSums',
                // level: 1,
                // tip: 'Bar Chart of Sums',
                shortcutKey : {
                    mac : 'b+s',
                    windows : 'b+s'
                }
            },{
                label: 'Stretched Bar Chart',
                value: 'StretchedBar',
                // level: 1,
                // tip: 'Stretched Bar Chart',
                shortcutKey : {
                    mac : 'b+t',
                    windows : 'b+t'
                }
            }
        ]
    },{
        tip: 'Geographic Map',
        label: 'Map',
        value: 'Map',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'm',
            windows : 'm'
        }
    },{
        tip: 'Count and Percent',
        label: 'Count and Percent',
        iconClass: 'tde-i tde-i-num-perc',
        groupId: 'numberpercentage',
        cssClassNames: 'tde-border-left',
        children: [{
            label: 'Count',
            groupId: 'count',
            children: [{
                label: 'Count Cases',
                value: 'CellCount',
                // level: 3
            },{
                label: 'Count by Section',
                value: 'SectionCount',
                // level: 3
            },{
                label: 'Totals',
                value: 'SectionSum',
                // level: 3
            }]
        },{
            label: 'Percent',
            groupId: 'percent',
            children: [{
                label: 'Percent of Cases',
                value: 'CellPercent',
                // level: 3
            },{
                label: 'Percent in Sections',
                value: 'SectionPercent',
                // level: 3
            },{
                type: 'divider'
            },{
                label: 'Overall Percent',
                value: 'OverallPercent',
                // level: 3
            },{
                label: 'Percent Column-wise',
                value: 'ColPercent',
                // level: 3
            },{
                label: 'Percent Row-wise',
                value: 'RowPercent',
                // level: 3
            }]
        },{
            label: 'Dividers',
            value: 'Dividers',
            // level: 2,
            shortcutKey : {
                mac : "command+Ctrl+p",
                windows : "Ctrl+Shift+p"
            }
        }]
    },{
        tip: 'Model Data',
        iconClass: 'tde-i tde-i-model',
        groupId: 'models',
        label: 'Model Data',
        // level: 1,
        children: [{
            label: 'Movable Line',
            children: [
                {
                    label: 'Add Movable Line on X - Y',
                    value: 'DiagRefLine',
                    // level: 4
                },{  //-- Inserted dynamically by fillColumnsPropsIntoMenu()
                    label: 'Add Movable Line on X - Y2',
                    value: 'DiagRefLineY2',
                    // level: 4
                }
            ]
        }, {
            label: 'Reference Lines',
            children: [
                {
                    label: 'Add Reference Line on X',
                    value: 'XRefLine',
                    // level: 4
                },{
                    label: 'Add Reference Line on Y',
                    value: 'YRefLine',
                    // level: 4
                },{  //-- Inserted dynamically by fillColumnsPropsIntoMenu()
                    label: 'Add Reference Line on Y2',
                    value: 'Y2RefLine',
                    // level: 4
                },
            ]
        },{
            label: 'Clear All Reference Lines',
            value: 'clearAllRefLines',
            // level: 1,
            shortcutKey : {
                mac : "command+\\",
                windows : "Ctrl+\\"
            }
        }]
    },{
        tip: 'Filter Data',
        label: 'Filter Data',
        groupId: 'filterOptions',
        iconClass: 'tde-i tde-i-filter',
        cssClassNames: 'tde-divider-right',
        children: [
            {
                label: 'Exclude Selected Cases',
                value: 'excludeSelected',
                // level: 2,
                shortcutKey : {
                    mac : "command+e",
                    windows : "Ctrl+e"
                }
            },
            {
                label: 'Keep Only Selected Cases',
                value: 'keepSelected',
                // level: 2,
                shortcutKey : {
                    mac : "command+k",
                    windows : "Ctrl+k"
                }
            },
            {
                label: 'Filter By',
                groupId: 'filterBy',
                fillColumns: true,
                children: []
            },
            {
                type: 'divider'
            },
            {
                label: 'Reset All Filters',
                value: 'resetAllFilter',
                // level: 2,
                shortcutKey : {
                    mac : "command+f",
                    windows : "Ctrl+f"
                }
            }
        ]
    },{
        tip: 'Screenshot',
        label: 'Screenshot',
        value: 'ImagePNG',
        iconClass: 'tde-i tde-i-screenshot',
        // level: 1,
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "command+s",
            windows : "Ctrl+s"
        }
    },{
        tip: 'Annotate',
        label: 'Annotate',
        iconClass: 'tde-i tde-i-annotate',
        groupId: 'annotate',
        dynamicGroup: 'more',
        children: [
            {
                label: 'Pencil',
                value: 'AnnotatePencilTool',
                title: 'Draw a freehand line with Pencil Tool',
                // level: 1
            },
            {
                label: 'Rectangle',
                value: 'AnnotateRectTool',
                title: 'Draw rectangles with the Rectangle Tool',
                // level: 1
            },
            {
                label: 'Circle',
                value: 'AnnotateCircleTool',
                title: 'Draw circles with the Circle Tool',
                // level: 1
            },
            {
                label: 'Arrow',
                value: 'AnnotateArrowTool',
                title: 'Draw arrows with the Arrow Tool',
                // level: 1
            },
            {
                label: 'Line',
                value: 'AnnotateStraightLineTool',
                title: 'Draw Straight Line with the Line Tool',
                // level: 1
            },
            {
                label: 'Text',
                value: 'AnnotateTextTool',
                title: 'Add text annotations with the Text Tool',
                // level: 1
            },
            {
                label: 'Image',
                value: 'AnnotateImageTool',
                title: 'Paste in images with the Image Tool'
            },
            {
                type: 'divider'
            },
            {
                label: 'Clear All',
                value: 'clearAllAnnotations',
                title: 'Clear all lines, rectangles, circles, arrows, text',
                // level: 1,
                shortcutKey : {
                    mac : "command+a",
                    windows : "Ctrl+a"
                }
            }
        ]
    },{
        tip: 'Settings',
        label: 'Settings',
        value: 'PlotSettings',
        iconClass: 'tde-i tde-i-settings',
        dynamicGroup: 'more',
        // level: 1,
        shortcutKey : {
            mac : "Option+e",
            windows : "Alt+e"
        }

    },{
        // groupId: 'accessibility',
        tip: 'Accessibility',
        label: 'Accessibility',
        // level: 1,
        value: 'AccessibilitySettings',
        iconClass: 'tde-i tde-i-accessibility',
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "Option+z",
            windows : "Alt+z"
        }
    },{
        groupId: 'help',
        tip: 'Help',
        label: 'Help',
        iconClass: 'tde-i tde-i-help-fill',
        cssClassNames: 'tde-border-left',
        // level: 1,
        dynamicGroup: '',
        children: [
            {
                label: 'Keyboard Shortcuts',
                value: 'KeyboardShortcuts',
                title: 'Keyboard Shortcuts',
                shortcutKey : {
                    mac : "command+/",
                    windows : "Ctrl+/"
                }
            }
        ]
    }];

    static MIDDLE = [{
        tip: 'Clear & Reset',
        iconClass: 'tde-i tde-i-reset',
        value: 'Mixup',
        // level: 1,
        cssClassNames: 'tde-divider-right',
        shortcutKey : {
            mac : 'command+r',
            windows : 'Ctrl+r'
        }
    },{
        tip: 'Undo / Redo',
        iconClass: 'tde-i tde-i-undo-redo',
        groupId: 'undoredo',
        cssClassNames: 'tde-divider-right',
        children: [{
            label: 'Undo',
            value: 'undo',
            shortcutKey : {
                mac : 'command+z',
                windows : 'Ctrl+z'
            }
        },
        {
            label: 'Redo',
            value: 'redo',
            shortcutKey : {
                mac : 'command+y',
                windows : 'Ctrl+y'
            }
        },
        {
            label: 'Reload Plot',
            value: 'reloadPlot'
        }]
    },{
        tip: 'Dot and Scatter Plot',
        label: 'Dot',
        value: 'Dot',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'd',
            windows : 'd'
        }
    },{
        tip: 'Line Graph',
        label: 'Line',
        dynamicGroup: 'graphs',
        groupId: 'line',
        children: [{
            label: 'Line Graph',
            value: 'Line',
            // level: 1,
            shortcutKey : {
                mac : 'l+g',
                windows : 'l+g'
            }
        },{
            label: 'Line Graph by Category',
            value: 'LineAndCategory',
            // level: 1,
            shortcutKey : {
                mac : 'l+c',
                windows : 'l+c'
            }
        }]
    },{
        tip: 'Pie Chart',
        label: 'Pie',
        value: 'Pie',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'p',
            windows : 'p'
        }
    },{
        tip: 'Bar Charts',
        label: 'Bar',
        dynamicGroup: 'graphs',
        groupId: 'bar',
        children: [
            {
                label: 'Bar Chart of Frequencies',
                value: 'BarChartOfFreq',
                // level: 1,
                // tip: 'Bar Chart of Frequencies',
                shortcutKey : {
                    mac : 'b+f',
                    windows : 'b+f'
                }
            },{
                label: 'Bar Chart of Values',
                value: 'BarChartOfValues',
                // level: 1,
                // tip: 'Bar Chart of Values',
                shortcutKey : {
                    mac : 'b+v',
                    windows : 'b+v'
                }
            },{
                label: 'Bar Chart of Sums',
                value: 'BarChartOfSums',
                // level: 1,
                // tip: 'Bar Chart of Sums',
                shortcutKey : {
                    mac : 'b+s',
                    windows : 'b+s'
                }
            },{
                label: 'Bar Chart of Means',
                value: 'BarChartOfMeans',
                // level: 1,
                // tip: 'Bar Chart of Means',
                shortcutKey : {
                    mac : 'b+m',
                    windows : 'b+m'
                }
            },{
                label: 'Stretched Bar Chart',
                value: 'StretchedBar',
                // level: 1,
                // tip: 'Stretched Bar Chart',
                shortcutKey : {
                    mac : 'b+t',
                    windows : 'b+t'
                }
            }
        ]
    },{
        tip: 'Histogram',
        label: 'Hist',
        groupId: 'histGroup',
        dynamicGroup: 'graphs',
        children: [
            {
                label: 'Frequency Histogram',
                value: 'FreqHistogram',
                shortcutKey : {
                    mac : 'h+f',
                    windows : 'h+f'
                }
            },{
                label: 'Relative Percentage Histogram',
                value: 'PercHistogram',
                shortcutKey : {
                    mac : 'h+p',
                    windows : 'h+p'
                }
            },{
                label: 'Relative Proportion Histogram',
                value: 'PropHistogram',
                shortcutKey : {
                    mac : 'h+r',
                    windows : 'h+r'
                }
            }
        ]
    },{
        tip: 'Box Plots',
        label: 'Box',
        groupId: 'box',
        dynamicGroup: 'graphs',
        children: [
            {
                label: 'Box Plot',
                value: 'Box',
                // level: 1,
                shortcutKey : {
                    mac : 'x+p',
                    windows : 'x+p'
                }
            },{
                label: 'Box Plot with Outliers',
                value: 'BoxAndOutlier',
                // level: 1,
                shortcutKey : {
                    mac : 'x+o',
                    windows : 'x+o'
                }
            },{
                label: 'Box and Dot Plot',
                value: 'BoxAndDot',
                // level: 1,
                shortcutKey : {
                    mac : 'x+d',
                    windows : 'x+d'
                }
            }
        ]
    },{
        tip: 'Geographic Map',
        label: 'Map',
        value: 'Map',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'm',
            windows : 'm'
        }
    },{
        tip: 'Count and Percent',
        label: 'Count and Percent',
        iconClass: 'tde-i tde-i-num-perc',
        groupId: 'numberpercentage',
        cssClassNames: 'tde-border-left',
        children: [{
            label: 'Count',
            groupId: 'count',
            children: [{
                label: 'Count Cases',
                value: 'CellCount',
                // level: 3
            },{
                label: 'Count by Section',
                value: 'SectionCount',
                // level: 3
            },{
                label: 'Totals',
                value: 'SectionSum',
                // level: 3
            }]
        },{
            label: 'Percent',
            groupId: 'percent',
            children: [{
                label: 'Percent of Cases',
                value: 'CellPercent',
                // level: 3
            },{
                label: 'Percent in Sections',
                value: 'SectionPercent',
                // level: 3
            },{
                type: 'divider'
            },{
                label: 'Overall Percent',
                value: 'OverallPercent',
                // level: 3
            },{
                label: 'Percent Column-wise',
                value: 'ColPercent',
                // level: 3
            },{
                label: 'Percent Row-wise',
                value: 'RowPercent',
                // level: 3
            }]
        },{
            label: 'Dividers',
            value: 'Dividers',
            // level: 2,
            shortcutKey : {
                mac : "command+Ctrl+p",
                windows : "Ctrl+Shift+p"
            }
        }]
    },{
        tip: 'Statistical Measures',
        label: 'Stats',
        groupId: 'stats',
        children: [{
                label: 'Mean',
                value: 'Mean',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+m",
                    windows : "Ctrl+Shift+m"
                }
            },{
                label: 'Median',
                value: 'Median',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+e",
                    windows : "Ctrl+Shift+e"
                }
            },{
                label: 'Mode',
                value: 'Mode',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+o",
                    windows : "Ctrl+Shift+o"
                }
            },{
                label: 'Mean Average Deviation',
                value: 'MeanAvDev',
                // level: 2,
                    shortcutKey : {
                        mac : "command+Ctrl+a",
                        windows : "Ctrl+Shift+a"
                    }
            },{
                label: 'Interquartile Range',
                value: 'IQR',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+i",
                    windows : "Ctrl+Shift+i"
                }
            },{
                label: 'Rounding',
                groupId: 'precisionGroup',
                // children: see roundingMenuChildren
            },{
                label: 'Labels on Statistics',
                value: 'ShowHideLabelsOnStats',
                shortcutKey : {
                    mac : "command+Ctrl+l",
                    windows : "Ctrl+Shift+l"
                }
            },
        ]
    },{
        tip: 'Model Data',
        iconClass: 'tde-i tde-i-model',
        groupId: 'models',
        label: 'Model Data',
        // level: 1,
        children: [{
            label: 'Least Squares Line',
            children: [{
                label: 'Least Squares Line',
                value: 'LeastSqByAttribute',
                // level: 3,
                shortcutKey : {
                    mac : "command+Ctrl+u",
                    windows : "Ctrl+Shift+u"
                }
            },{
                label: 'Line by Category',
                value: 'LeastSqByCategory',
                // level: 3
            }]
        },{
            label: 'Movable Line',
            children: [
                {
                    label: 'Add Movable Line on X - Y',
                    value: 'DiagRefLine',
                    // level: 4
                },{  //-- Inserted dynamically by fillColumnsPropsIntoMenu()
                    label: 'Add Movable Line on X - Y2',
                    value: 'DiagRefLineY2',
                    // level: 4
                }
            ]
        },{
            label: 'Reference Lines',
            children: [
                {
                    label: 'Add Reference Line on X',
                    value: 'XRefLine',
                    // level: 4
                },{
                    label: 'Add Reference Line on Y',
                    value: 'YRefLine',
                    // level: 4
                },{  //-- Inserted dynamically by fillColumnsPropsIntoMenu()
                    label: 'Add Reference Line on Y2',
                    value: 'Y2RefLine',
                    // level: 4
                },
            ]
        },{
            label: 'Clear All Reference Lines',
            value: 'clearAllRefLines',
            // level: 1,
            shortcutKey : {
                mac : "command+\\",
                windows : "Ctrl+\\"
            }
        }]
    },{
        tip: 'Sample Data',
        value: 'randomSample',
        iconClass: 'tde-i tde-i-sample',
        label: 'Sample Data',
        // level: 1,
        shortcutKey : {
            mac : "Option+d",
            windows : "Alt+d"
        }
    },{
        tip: 'Filter Data',
        label: 'Filter Data',
        groupId: 'filterOptions',
        iconClass: 'tde-i tde-i-filter',
        cssClassNames: 'tde-divider-right',
        children: [
        {
            label: 'Exclude Selected Cases',
            value: 'excludeSelected',
            // level: 2,
            shortcutKey : {
                mac : "command+e",
                windows : "Ctrl+e"
            }
        },
        {
            label: 'Keep Only Selected Cases',
            value: 'keepSelected',
            // level: 2,
            shortcutKey : {
                mac : "command+k",
                windows : "Ctrl+k"
            }
        },
        {
            label: 'Filter By',
            groupId: 'filterBy',
            fillColumns: true,
            children: []
        },
        {
            type: 'divider'
        },
        {
            label: 'Reset All Filters',
            value: 'resetAllFilter',
            // level: 2,
            shortcutKey : {
                mac : "command+f",
                windows : "Ctrl+f"
            }
        }]
    },{
        tip: 'Screenshot',
        label: 'Screenshot',
        value: 'ImagePNG',
        iconClass: 'tde-i tde-i-screenshot',
        // level: 1,
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "command+s",
            windows : "Ctrl+s"
        }
    },{
        tip: 'Annotate',
        label: 'Annotate',
        iconClass: 'tde-i tde-i-annotate',
        groupId: 'annotate',
        dynamicGroup: 'more',
        children: [
            {
                label: 'Pencil',
                value: 'AnnotatePencilTool',
                title: 'Draw a freehand line with Pencil Tool',
                // level: 1
            },
            {
                label: 'Rectangle',
                value: 'AnnotateRectTool',
                title: 'Draw rectangles with the Rectangle Tool',
                // level: 1
            },
            {
                label: 'Circle',
                value: 'AnnotateCircleTool',
                title: 'Draw circles with the Circle Tool',
                // level: 1
            },
            {
                label: 'Arrow',
                value: 'AnnotateArrowTool',
                title: 'Draw arrows with the Arrow Tool',
                // level: 1
            },
            {
                label: 'Line',
                value: 'AnnotateStraightLineTool',
                title: 'Draw Straight Line with the Line Tool',
                // level: 1
            },
            {
                label: 'Text',
                value: 'AnnotateTextTool',
                title: 'Add text annotations with the Text Tool',
                // level: 1
            },
            {
                label: 'Image',
                value: 'AnnotateImageTool',
                title: 'Paste in images with the Image Tool'
            },
            {
                type: 'divider'
            },
            {
                label: 'Clear All',
                value: 'clearAllAnnotations',
                title: 'Clear all lines, rectangles, circles, arrows, text',
                // level: 1,
                shortcutKey : {
                    mac : "command+a",
                    windows : "Ctrl+a"
                }
            }
        ]
    },{
        tip: 'Settings',
        label: 'Settings',
        value: 'PlotSettings',
        iconClass: 'tde-i tde-i-settings',
        dynamicGroup: 'more',
        // level: 1,
        shortcutKey : {
            mac : "Option+e",
            windows : "Alt+e"
        }

    },{
        tip: 'Accessibility',
        label: 'Accessibility',
        // level: 1,
        value: 'AccessibilitySettings',
        iconClass: 'tde-i tde-i-accessibility',
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "Option+z",
            windows : "Alt+z"
        }
    },{
        groupId: 'help',
        tip: 'Help',
        label: 'Help',
        iconClass: 'tde-i tde-i-help-fill',
        cssClassNames: 'tde-border-left',
        // level: 1,
        dynamicGroup: '',
        children: [
            {
                label: 'User Guide',
                value: 'SupportGuide',
                title: 'Tuva User Guide',
                tip: 'Tuva User Guide. Opens in a new tab.',
                role: 'link'
            },
            {
                label: 'Support',
                value: 'Support',
                title: 'Tuva Tools Support',
                tip: 'Tuva Tools Support. Opens in a new tab.',
                role: 'link'
            },
            {
                label: 'Keyboard Shortcuts',
                value: 'KeyboardShortcuts',
                title: 'Keyboard Shortcuts',
                shortcutKey : {
                    mac : "command+/",
                    windows : "Ctrl+/"
                }
            },
            {
                label: 'Tutorials',
                value: 'Tutorials',
                title: 'Tutorials',
                tip: 'Tutorials. Opens in a new tab.',
                role: 'link'
            },
            {
                label: 'Tour',
                value: 'tour',
                title: 'Tour',
                tip: 'Tour.'
            }
        ]
    }];

    static HIGH = [{
        tip: 'Clear & Reset',
        iconClass: 'tde-i tde-i-reset',
        value: 'Mixup',
        // level: 1,
        cssClassNames: 'tde-divider-right',
        shortcutKey : {
            mac : 'command+r',
            windows : 'Ctrl+r'
        }
    },{
        tip: 'Undo / Redo',
        iconClass: 'tde-i tde-i-undo-redo',
        groupId: 'undoredo',
        cssClassNames: 'tde-divider-right',
        children: [{
            label: 'Undo',
            value: 'undo',
            shortcutKey : {
                mac : 'command+z',
                windows : 'Ctrl+z'
            }
        },
        {
            label: 'Redo',
            value: 'redo',
            shortcutKey : {
                mac : 'command+y',
                windows : 'Ctrl+y'
            }
        },
        {
            label: 'Reload Plot',
            value: 'reloadPlot'
        }]
    },{
        tip: 'Dot and Scatter Plot',
        label: 'Dot',
        value: 'Dot',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'd',
            windows : 'd'
        }
    },{
        tip: 'Line Graph',
        label: 'Line',
        dynamicGroup: 'graphs',
        groupId: 'line',
        children: [{
            label: 'Line Graph',
            value: 'Line',
            // level: 1,
            shortcutKey : {
                mac : 'l+g',
                windows : 'l+g'
            }
        },{
            label: 'Line Graph by Category',
            value: 'LineAndCategory',
            // level: 1,
            shortcutKey : {
                mac : 'l+c',
                windows : 'l+c'
            }
        }]
    },{
        tip: 'Pie Chart',
        label: 'Pie',
        value: 'Pie',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'p',
            windows : 'p'
        }
    },{
        tip: 'Bar Charts',
        label: 'Bar',
        dynamicGroup: 'graphs',
        groupId: 'bar',
        children: [
            {
                label: 'Bar Chart of Frequencies',
                value: 'BarChartOfFreq',
                // level: 1,
                // tip: 'Bar Chart of Frequencies',
                shortcutKey : {
                    mac : 'b+f',
                    windows : 'b+f'
                }
            },{
                label: 'Bar Chart of Values',
                value: 'BarChartOfValues',
                // level: 1,
                // tip: 'Bar Chart of Values',
                shortcutKey : {
                    mac : 'b+v',
                    windows : 'b+v'
                }
            },{
                label: 'Bar Chart of Sums',
                value: 'BarChartOfSums',
                // level: 1,
                // tip: 'Bar Chart of Sums',
                shortcutKey : {
                    mac : 'b+s',
                    windows : 'b+s'
                }
            },{
                label: 'Bar Chart of Means',
                value: 'BarChartOfMeans',
                // level: 1,
                // tip: 'Bar Chart of Means',
                shortcutKey : {
                    mac : 'b+m',
                    windows : 'b+m'
                }
            },{
                label: 'Stretched Bar Chart',
                value: 'StretchedBar',
                // level: 1,
                // tip: 'Stretched Bar Chart',
                shortcutKey : {
                    mac : 'b+t',
                    windows : 'b+t'
                }
            }
        ]
    },{
        tip: 'Histogram',
        label: 'Hist',
        groupId: 'histGroup',
        dynamicGroup: 'graphs',
        children: [
            {
                label: 'Frequency Histogram',
                value: 'FreqHistogram',
                shortcutKey : {
                    mac : 'h+f',
                    windows : 'h+f'
                }
            },{
                label: 'Relative Percentage Histogram',
                value: 'PercHistogram',
                shortcutKey : {
                    mac : 'h+p',
                    windows : 'h+p'
                }
            },{
                label: 'Relative Proportion Histogram',
                value: 'PropHistogram',
                shortcutKey : {
                    mac : 'h+r',
                    windows : 'h+r'
                }
            }
        ]
    },{
        tip: 'Box Plots',
        label: 'Box',
        groupId: 'box',
        dynamicGroup: 'graphs',
        children: [
            {
                label: 'Box Plot',
                value: 'Box',
                // level: 1,
                shortcutKey : {
                    mac : 'x+p',
                    windows : 'x+p'
                }
            },{
                label: 'Box Plot with Outliers',
                value: 'BoxAndOutlier',
                // level: 1,
                shortcutKey : {
                    mac : 'x+o',
                    windows : 'x+o'
                }
            },{
                label: 'Box and Dot Plot',
                value: 'BoxAndDot',
                // level: 1,
                shortcutKey : {
                    mac : 'x+d',
                    windows : 'x+d'
                }
            }
        ]
    },{
        tip: 'Geographic Map',
        label: 'Map',
        value: 'Map',
        // level: 1,
        dynamicGroup: 'graphs',
        shortcutKey : {
            mac : 'm',
            windows : 'm'
        }
    },{
        tip: 'Count and Percent',
        label: 'Count and Percent',
        iconClass: 'tde-i tde-i-num-perc',
        groupId: 'numberpercentage',
        cssClassNames: 'tde-border-left',
        children: [{
            label: 'Count',
            groupId: 'count',
            children: [{
                label: 'Count Cases',
                value: 'CellCount',
                // level: 3
            },{
                label: 'Count by Section',
                value: 'SectionCount',
                // level: 3
            },{
                label: 'Totals',
                value: 'SectionSum',
                // level: 3
            }]
        },{
            label: 'Percent',
            groupId: 'percent',
            children: [{
                label: 'Percent of Cases',
                value: 'CellPercent',
                // level: 3
            },{
                label: 'Percent in Sections',
                value: 'SectionPercent',
                // level: 3
            },{
                type: 'divider'
            },{
                label: 'Overall Percent',
                value: 'OverallPercent',
                // level: 3
            },{
                label: 'Percent Column-wise',
                value: 'ColPercent',
                // level: 3
            },{
                label: 'Percent Row-wise',
                value: 'RowPercent',
                // level: 3
            }]
        },{
            label: 'Dividers',
            value: 'Dividers',
            // level: 2,
            shortcutKey : {
                mac : "command+Ctrl+p",
                windows : "Ctrl+Shift+p"
            }
        }]
    },{
        tip: 'Statistical Measures',
        label: 'Stats',
        groupId: 'stats',
        children: [{
                label: 'Mean',
                value: 'Mean',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+m",
                    windows : "Ctrl+Shift+m"
                }
            },{
                label: 'Median',
                value: 'Median',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+e",
                    windows : "Ctrl+Shift+e"
                }
            },{
                label: 'Mode',
                value: 'Mode',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+o",
                    windows : "Ctrl+Shift+o"
                }
            },{
                label: 'Mean Average Deviation',
                value: 'MeanAvDev',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+a",
                    windows : "Ctrl+Shift+a"
                }
            },{
                label: 'Interquartile Range',
                value: 'IQR',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+i",
                    windows : "Ctrl+Shift+i"
                }
            },{
                label: 'Standard Deviation',
                value: 'StDev',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+s",
                    windows : "Ctrl+Shift+s"
                }
            },{
                label: 'Variance',
                value: 'Variance',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+v",
                    windows : "Ctrl+Shift+v"
                }
            },{
                label: 'Standard Error',
                value: 'StdError',
                // level: 2,
                shortcutKey : {
                    mac : "command+Ctrl+r",
                    windows : "Ctrl+Shift+r"
                }
            },{
                label: 'Rounding',
                groupId: 'precisionGroup',
                // children: see roundingMenuChildren
            },{
                label: 'Labels on Statistics',
                value: 'ShowHideLabelsOnStats',
                shortcutKey : {
                    mac : "command+Ctrl+l",
                    windows : "Ctrl+Shift+l"
                }
            },
        ]
    },{
        tip: 'Model Data',
        iconClass: 'tde-i tde-i-model',
        groupId: 'models',
        label: 'Model Data',
        // level: 1,
        children: [{
            ariaLabel: 'Plot Functions',
            label: 'f(x)',
            value: 'modelFunction',
            // level: 2,
            shortcutKey : {
                mac : "Option+f",
                windows : "Alt+f"
            }
        },{
            label: 'Least Squares Line',
            children: [{
                label: 'Least Squares Line',
                value: 'LeastSqByAttribute',
                // level: 3,
                shortcutKey : {
                    mac : "command+Ctrl+u",
                    windows : "Ctrl+Shift+u"
                }
            },{
                label: 'Line by Category',
                value: 'LeastSqByCategory',
                // level: 3
            }]
        },{
            label: 'Movable Line',
            children: [
                {
                    label: 'Add Movable Line on X - Y',
                    value: 'DiagRefLine',
                    // level: 4
                },{  //-- Inserted dynamically by fillColumnsPropsIntoMenu()
                    label: 'Add Movable Line on X - Y2',
                    value: 'DiagRefLineY2',
                    // level: 4
                }
            ]
        },{
            label: 'Reference Lines',
            children: [
                {
                    label: 'Add Reference Line on X',
                    value: 'XRefLine',
                    // level: 4
                },{
                    label: 'Add Reference Line on Y',
                    value: 'YRefLine',
                    // level: 4
                },{  //-- Inserted dynamically by fillColumnsPropsIntoMenu()
                    label: 'Add Reference Line on Y2',
                    value: 'Y2RefLine',
                    // level: 4
                },
            ]
        },{
            label: 'Show Squares',
            value: 'ShowHideSquaresOnLines',
            // level: 3,
            shortcutKey : {
                mac : "command+Ctrl+w",
                windows : "Ctrl+Shift+w"
            }
        },{
            label: 'Clear All Reference Lines',
            value: 'clearAllRefLines',
            // level: 1,
            shortcutKey : {
                mac : "command+\\",
                windows : "Ctrl+\\"
            }
        }]
    },{
        tip: 'Sample Data',
        value: 'randomSample',
        iconClass: 'tde-i tde-i-sample',
        label: 'Sample Data',
        // level: 1,
        shortcutKey : {
            mac : "Option+d",
            windows : "Alt+d"
        }
    },{
        tip: 'Filter Data',
        label: 'Filter Data',
        groupId: 'filterOptions',
        iconClass: 'tde-i tde-i-filter',
        cssClassNames: 'tde-divider-right',
        children: [
        {
            label: 'Exclude Selected Cases',
            value: 'excludeSelected',
            // level: 2,
            shortcutKey : {
                mac : "command+e",
                windows : "Ctrl+e"
            }
        },
        {
            label: 'Keep Only Selected Cases',
            value: 'keepSelected',
            // level: 2,
            shortcutKey : {
                mac : "command+k",
                windows : "Ctrl+k"
            }
        },
        {
            label: 'Filter By',
            groupId: 'filterBy',
            fillColumns: true,
            children: []
        },
        {
            type: 'divider'
        },
        {
            label: 'Reset All Filters',
            value: 'resetAllFilter',
            // level: 2,
            shortcutKey : {
                mac : "command+f",
                windows : "Ctrl+f"
            }
        }]
    },{
        tip: 'Screenshot',
        label: 'Screenshot',
        value: 'ImagePNG',
        iconClass: 'tde-i tde-i-screenshot',
        // level: 1,
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "command+s",
            windows : "Ctrl+s"
        }
    },{
        tip: 'Annotate',
        label: 'Annotate',
        iconClass: 'tde-i tde-i-annotate',
        groupId: 'annotate',
        dynamicGroup: 'more',
        children: [
            {
                label: 'Pencil',
                value: 'AnnotatePencilTool',
                title: 'Draw a freehand line with Pencil Tool',
                // level: 1
            },
            {
                label: 'Rectangle',
                value: 'AnnotateRectTool',
                title: 'Draw rectangles with the Rectangle Tool',
                // level: 1
            },
            {
                label: 'Circle',
                value: 'AnnotateCircleTool',
                title: 'Draw circles with the Circle Tool',
                // level: 1
            },
            {
                label: 'Arrow',
                value: 'AnnotateArrowTool',
                title: 'Draw arrows with the Arrow Tool',
                // level: 1
            },
            {
                label: 'Line',
                value: 'AnnotateStraightLineTool',
                title: 'Draw Straight Line with the Line Tool',
                // level: 1
            },
            {
                label: 'Text',
                value: 'AnnotateTextTool',
                title: 'Add text annotations with the Text Tool',
                // level: 1
            },
            {
                label: 'Image',
                value: 'AnnotateImageTool',
                title: 'Paste in images with the Image Tool'
            },
            {
                type: 'divider'
            },
            {
                label: 'Clear All',
                value: 'clearAllAnnotations',
                title: 'Clear all lines, rectangles, circles, arrows, text',
                // level: 1,
                shortcutKey : {
                    mac : "command+a",
                    windows : "Ctrl+a"
                }
            }
        ]
    },{
        tip: 'Settings',
        label: 'Settings',
        value: 'PlotSettings',
        iconClass: 'tde-i tde-i-settings',
        dynamicGroup: 'more',
        // level: 1,
        shortcutKey : {
            mac : "Option+e",
            windows : "Alt+e"
        }

    },{
        tip: 'Accessibility',
        label: 'Accessibility',
        // level: 1,
        value: 'AccessibilitySettings',
        iconClass: 'tde-i tde-i-accessibility',
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "Option+z",
            windows : "Alt+z"
        }
    },{
        groupId: 'help',
        tip: 'Help',
        label: 'Help',
        iconClass: 'tde-i tde-i-help-fill',
        cssClassNames: 'tde-border-left',
        // level: 1,
        dynamicGroup: '',
        children: [
            {
                label: 'User Guide',
                value: 'SupportGuide',
                title: 'Tuva User Guide',
                tip: 'Tuva User Guide. Opens in a new tab.',
                role: 'link'
            },
            {
                label: 'Support',
                value: 'Support',
                title: 'Tuva Tools Support',
                tip: 'Tuva Tools Support. Opens in a new tab.',
                role: 'link'
            },
            {
                label: 'Keyboard Shortcuts',
                value: 'KeyboardShortcuts',
                title: 'Keyboard Shortcuts',
                shortcutKey : {
                    mac : "command+/",
                    windows : "Ctrl+/"
                }
            },
            {
                label: 'Tutorials',
                value: 'Tutorials',
                title: 'Tutorials',
                tip: 'Tutorials. Opens in a new tab.',
                role: 'link'
            },
            {
                label: 'Tour',
                value: 'tour',
                title: 'Tour',
                tip: 'Tour.'
            }
        ]
    }];

    static DRAW = [{
        tip: 'Undo/Redo',
        iconClass: 'tde-i tde-i-undo-redo',
        cssClassNames: 'tde-divider-right',
        groupId: 'undoredo',
        children: [{
            label: 'Undo',
            value: 'undo',
            shortcutKey : {
                mac : 'command+z',
                windows : 'Ctrl+z'
            }
        },
        {
            label: 'Redo',
            value: 'redo',
            shortcutKey : {
                mac : 'command+y',
                windows : 'Ctrl+y'
            }
        },
        {
            label: 'Reload Plot',
            value: 'reloadPlot'
        }]
    },{
        tip: 'Picture',
        // label: 'Screenshot',
        value: 'ImagePNG',
        iconClass: 'tde-i tde-i-screenshot',
        // level: 1,
        dynamicGroup: 'more',
        shortcutKey : {
            mac : "command+s",
            windows : "Ctrl+s"
        }
    },
    {
        label: 'Pencil',
        value: 'AnnotatePencilTool',
        title: 'Draw a freehand line with Pencil Tool',
        // level: 1
    },
    {
        label: 'Rectangle',
        value: 'AnnotateRectTool',
        title: 'Draw rectangles with the Rectangle Tool',
        // level: 1
    },
    {
        label: 'Circle',
        value: 'AnnotateCircleTool',
        title: 'Draw circles with the Circle Tool',
        // level: 1
    },
    {
        label: 'Arrow',
        value: 'AnnotateArrowTool',
        title: 'Draw arrows with the Arrow Tool',
        // level: 1
    },
    {
        label: 'Line',
        value: 'AnnotateStraightLineTool',
        title: 'Draw Straight Line with the Line Tool',
        // level: 1
    },
    {
        label: 'Text',
        value: 'AnnotateTextTool',
        title: 'Add text annotations with the Text Tool',
        // level: 1
    },
    {
        label: 'Image',
        value: 'AnnotateImageTool',
        title: 'Paste in images with the Image Tool',
        // level: 1
    },
    {
        label: 'Clear All',
        value: 'clearAllAnnotations',
        title: 'Clear all lines, rectangles, circles, arrows, text',
        // level: 1,
        shortcutKey : {
            mac : "command+a",
            windows : "Ctrl+a"
        }
    }];
}

const samplingStatesMenuChildren = [{
    label: 'Population Mean (μ)',
    value: 'PopulationMean',
    // level: 2
},{
    label: 'Population Median',
    value: 'PopulationMedian',
    // level: 2
},{
    label: 'Population Standard Deviation (𝜎)',
    value: 'PopulationStDev',
    // level: 2
},{
    label: 'Population Variance (𝜎²)',
    value: 'PopulationVariance',
    // level: 2
},{
    label: 'Population Interquartile Range',
    value: 'PopulationIQR',
    // level: 2
},{
    type: 'divider'
},{
    label: 'Sample Mean (x̄)',
    value: 'Mean',
    // level: 2
},{
    label: 'Sample Median',
    value: 'Median',
    // level: 2
},{
    label: 'Sample Standard Deviation (s)',
    value: 'StDev',
    // level: 2
},{
    label: 'Sample Variance (s²)',
    value: 'Variance',
    // level: 2
},{
    label: 'Sample Interquartile Range',
    value: 'IQR',
    // level: 2
},{
    label: 'Standard Error',
    value: 'StdError',
    // level: 2,
},{
    type: 'divider'
},{
    label: 'Mode',
    value: 'Mode',
    // level: 2
},{
    label: 'Mean Average Deviation',
    value: 'MeanAvDev',
    // level: 2,
    shortcutKey : {
        mac : "command+Ctrl+a",
        windows : "Ctrl+Shift+a"
    }
},{
    label: 'Rounding',
    groupId: 'precisionGroup',
    // children: see roundingMenuChildren
},{
    label: 'Labels on Statistics',
    value: 'ShowHideLabelsOnStats'
}]

const samplingDistributionMenuChildren = [{
    label: 'Population Mean (μ)',
    value: 'PopulationMean',
    // level: 2
},{
    label: 'Population Median',
    value: 'PopulationMedian',
    // level: 2
},{
    label: 'Population Standard Deviation (𝜎)',
    value: 'PopulationStDev',
    // level: 2
},{
    label: 'Population Variance (𝜎²)',
    value: 'PopulationVariance',
    // level: 2
},{
    label: 'Population Interquartile Range',
    value: 'PopulationIQR',
    // level: 2
},{
    type: 'divider'
},{
    label: 'Mean of Distribution',
    value: 'Mean',
    // level: 2
},{
    label: 'Median of Distribution',
    value: 'Median',
    // level: 2
},{
    label: 'Standard Deviation of Distribution',
    value: 'StDev',
    // level: 2
},{
    label: 'Variance of Distribution',
    value: 'Variance',
    // level: 2
},{
    label: 'Interquartile Range of Distribution',
    value: 'IQR',
    // level: 2
},{
    type: 'divider'
},{
    label: 'Mode',
    value: 'Mode',
    // level: 2
},{
    label: 'Mean Average Deviation',
    value: 'MeanAvDev',
    // level: 2,
    shortcutKey : {
        mac : "command+Ctrl+a",
        windows : "Ctrl+Shift+a"
    }
},{
    label: 'Rounding',
    groupId: 'precisionGroup',
    // children: see roundingMenuChildren
},{
    label: 'Labels on Statistics',
    value: 'ShowHideLabelsOnStats'
}]

const samplingPopulationMenuChildren = [{
    label: 'Population Mean (μ)',
    value: 'Mean',
    // level: 2
},{
    label: 'Population Median',
    value: 'Median',
    // level: 2
},{
    label: 'Population Standard Deviation (𝜎)',
    value: 'StDev',
    // level: 2
},{
    label: 'Population Variance (𝜎²)',
    value: 'Variance',
    // level: 2
},{
    label: 'Population Interquartile Range',
    value: 'IQR',
    // level: 2
},{
    type: 'divider'
},{
    label: 'Mode',
    value: 'Mode',
    // level: 2
},{
    label: 'Mean Average Deviation',
    value: 'MeanAvDev',
    // level: 2,
    shortcutKey : {
        mac : "command+Ctrl+a",
        windows : "Ctrl+Shift+a"
    }
},{
    label: 'Rounding',
    groupId: 'precisionGroup',
    // children: see roundingMenuChildren
},{
    label: 'Labels on Statistics',
    value: 'ShowHideLabelsOnStats'
}]

// To clean extra divider menus after filtering
const cleanExtraDividers = function(menus) {
    return menus.filter((menu, index) => {
        if(menu.type === 'divider' &&
            (index === 0 || index === menus.length-1 || (menus[index-1] || {}).type === 'divider')) {
            return false;
        } else {
            return true;
        }
    });
}

// To filter menus
const filterMenus = function(visibleItems, menus = ToolbarMenus.DEFAULT) {
    return menus.filter((menu) => {
        if(menu.children && menu.children.length) {
            menu.children = cleanExtraDividers(filterMenus(visibleItems, menu.children));
            return menu.children.length > 0;
        } else if(menu.value || menu.groupId) {
            return visibleItems.indexOf(menu.value || menu.groupId) >= 0;
        } else {
            return menu.type === 'divider';
        }
    })
}

// save for possible future BubbleChart menu; removed from default menu on 2025-02-05 CDM
//  see BubbleChart in keymap.js, ToolbarComponent.jsx, and ToolbarMenus.js
const bubbleChartMenu = [
    {
        tip: 'Dot and Scatter Plot',
        label: 'Dot',
        dynamicGroup: 'graphs',
        groupId: 'dot',
        children: [{
            label: 'Dot Plot',
            value: 'Dot',
            dynamicGroup: 'graphs',
            shortcutKey : {
                mac : 'd',
                windows : 'd'
            }
        },{
            label: 'Scatterplot',
            value: 'Scatter',
            dynamicGroup: 'graphs',
            shortcutKey : {
                mac : 's',
                windows : 's'
            }
        },{
            label: 'Bubble Chart',
            value: 'BubbleChart',
            shortcutKey : {
                mac : 'b+c',
                windows : 'b+c'
            }
        }
        ]
    },{
        tip: 'Geographic Map',
        label: 'Map',
        groupId: 'map',
        dynamicGroup: 'graphs',
        children: [
            {
                label: 'Map',
                value: 'Map',
                shortcutKey : {
                    mac : 'm+p',
                    windows : 'm+p'
                }
            },{
                label: 'Map and Bubble',
                value: 'MapAndBubble',
                shortcutKey : {
                    mac : 'm+b',
                    windows : 'm+b'
                }
            },{
                label: 'Map and Line',
                value: 'MapAndLine',
                shortcutKey : {
                    mac : 'm+l',
                    windows : 'M+l'
                }
            }
        ]
    }
]

const roundingMenuChildren = [{
    label: 'Significant Figures Only',
    value: 'precision0',
    shortcutKey: {
        mac: "command+Ctrl+0",
        windows: "Ctrl+Shift+0"
    }
},{
    label: 'Less Precision',
    value: 'precisionDelta-1',
    shortcutKey : {
        mac : "command+Ctrl+1",
        windows : "Ctrl+Shift+1"
    }
},{
    label: 'More Precision',
    value: 'precisionDelta+1',
    shortcutKey : {
        mac : "command+Ctrl+2",
        windows : "Ctrl+Shift+2"
    }
}]
// },{
//     label: 'High Precision: +6 digits',
//     value: 'precision6',
//     shortcutKey : {
//         mac : "command+Ctrl+6",
//         windows : "Ctrl+Shift+6"
//     }
// },{
//     label: 'Extra Precision',
//     value: 'current-precision',
// }]

export { filterMenus, samplingStatesMenuChildren, samplingDistributionMenuChildren, samplingPopulationMenuChildren, roundingMenuChildren };
export default ToolbarMenus;
